import { useState } from "react";
import { Form, Link, useActionData } from "react-router-dom";

import showIcon from "../assets/show-icon.svg";
import hideIcon from "../assets/hide-icon.svg";
import arrowLeft from "../assets/arrow-left.svg";

import GoogleButton from "./GoogleButtonAuth";

const AuthForm = ({
  title,
  fields,
  method,
  buttonText,
  googleButtonText,
  children,
  textInput,
  handleSubmit,
  roleName,
  ...props
}) => {
  const [showPassword, setShowPassword] = useState({
    password: false,
    repeat_password: false,
  });

  const [passwordValue, setPasswordValue] = useState({});
  const [handleValue, setHandleValue] = useState({});
  const [error, setError] = useState(false);

  const actionData = useActionData();
  console.log("action data", actionData?.errors);

  const handlePasswordVisibility = (fieldName) => {
    setShowPassword((prevState) => ({
      ...prevState,
      [fieldName]: !prevState[fieldName],
    }));
  };

  const handleRepeatPassword = (event) => {
    const { name, value } = event.target;

    setPasswordValue((prevState) => {
      const updatedState = {
        ...prevState,
        [name]: value,
      };

      if (
        name === "password_confirmation" &&
        value &&
        updatedState.password !== value
      ) {
        setError(true);
      } else {
        setError(false);
      }

      return updatedState;
    });
  };

  const handleValueInput = (event) => {
    const { name, value } = event.target;

    setHandleValue((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleFinalSubmit = (e) => {
    e.preventDefault();
    handleSubmit(handleValue);
  };

  return (
    <div className="login-register-wrapper">
      <div className="back-to-home-form">
        <Link to="/">
          <img src={arrowLeft} alt="arrow" />
          Back to Home
        </Link>
      </div>
      <div className="row-essy">
        <div className="col-essy-md-6 col-essy-lg-6">
          <div className="form-parent">
            <div className="form-wrapper">
              <h1>{title}</h1>
              <Form
                method={method}
                {...props}
                {...(handleSubmit ? { onSubmit: handleFinalSubmit } : {})}
              >
                {fields.map((curr, index) => (
                  <div className="form-group" key={index}>
                    <label>
                      <span>
                        {curr.label}
                        <p>{curr.textInput}</p>
                      </span>
                      <input
                        value={curr.value}
                        required
                        onChange={(e) => {
                          handleValueInput(e);
                          handleRepeatPassword(e);
                        }}
                        type={
                          curr.type === "password"
                            ? showPassword[curr.name]
                              ? "text"
                              : "password"
                            : curr.type
                        }
                        placeholder={curr.placeholder}
                        name={curr.name}
                      />
                    </label>
                    {curr.type === "password" && (
                      <button
                        onClick={() => handlePasswordVisibility(curr.name)}
                        type="button"
                        className="toggle-password-btn"
                      >
                        {showPassword[curr.name] ? (
                          <img src={showIcon} alt="show icon" />
                        ) : (
                          <img src={hideIcon} alt="hide icon" />
                        )}
                      </button>
                    )}
                  </div>
                ))}

                {error && <p className="error-text">Passwords do not match!</p>}

                {actionData?.error && (
                  <p className="error-message">{actionData.error}</p>
                )}

                {Array.isArray(actionData?.errors) &&
                  actionData.errors.length > 0 && (
                    <ul className="error-list">
                      {actionData.errors.map((errObj, idx) =>
                        Object.entries(errObj).map(([field, messages]) =>
                          messages.map((msg, i) => (
                            <li
                              key={`${idx}-${field}-${i}`}
                              className="error-message"
                            >
                              {msg}
                            </li>
                          ))
                        )
                      )}
                    </ul>
                  )}

                <button type="submit" className="btn-all-white">
                  {buttonText}
                </button>
              </Form>
              {googleButtonText && (
                <div className="auth-google-wrapper">
                  <p>Or</p>
                  <GoogleButton roleName={roleName} text={googleButtonText} />
                </div>
              )}
            </div>
            {children}
          </div>
        </div>
        <div className="col-essy-md-6 col-essy-lg-6">
          <div className="login-register-bg"></div>
        </div>
      </div>
    </div>
  );
};

export default AuthForm;
